import {logoutUser} from "services/AuthService";

export const logout = (onLogout) => {
  logoutUser(onLogout);
  return {
    type: "USER_LOGOUT"
  }
};
